export default __webpack_public_path__ + "static/chocpops-health-1-mobile-133d36ba0e128acd6692fa781e1f56f1.png";